export default async function (filePath, cdn = false) {
    // load the manifest
    const manifest = await $.getJSON('/assets/manifest.json');

    let host = cdn ? CONFIG.cdn : '';

    if (manifest[filePath]) {
        return host + '/' + manifest[filePath];
    }

    return host + '/' + filePath;
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/version.js